import { ContentType, DynamicContentType } from '../../types/content.types.js'

export type GridData = {
  backgroundColor: 'none' | 'primary' | 'accent'
  numberOfColumns: number
  content: (DynamicContentType<any> | ContentType<any>)[][]
  columns: string
  gridLayout: string
  marginBottom: string
  marginTop: string
  topLine?: boolean
  bottomLine?: boolean
  gap?: string
  mobileDirection?: 'normal' | 'reverse'
}

export const grid: DynamicContentType<GridData> = {
  name: 'grid',
  viewName: 'Sektion',
  featureKey: 'grid',
  default: true,
  uuid: '',
  data: {
    backgroundColor: 'none',
    numberOfColumns: 1,
    content: [[], []],
    columns: '1fr',
    gridLayout: '1fr',
    marginBottom: '1rem',
    marginTop: '0',
    gap: 'gap-4',
  },
}
